import { testimonials } from "@/mocks/homeData";

export default function Testimonials() {
  return (
    <section
      id="reviews"
      className="w-full bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <span className="text-sm font-bold text-accent-600">
            来自读者的真实口碑
          </span>
          <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
            他们说，奇妙漫画网让人上头
          </h2>
          <p className="mt-2 text-sm text-foreground-700 md:text-base">
            从通勤族到大学生，越来越多的人把这里当成了每日的快乐补给站。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={`${t.name}的头像`}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-950">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-600">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}